import useStoryblok from 'storyblok/storyblok-hook';
import { getStory } from 'storyblok/storyblok';
import { FC, useEffect } from 'react';
import { GetStaticProps } from 'next';
import { FaqPage } from '@components/storyblok/Faq/FaqPage';
import { ISbStoryData } from '@storyblok/react';
import { getValidationTime } from '@lib/utils';

const FAQ: FC<{ story: ISbStoryData }> = ({ story }) => {
  const { content } = useStoryblok(story);

  useEffect(() => {
    const htmlRoot = document.getElementsByTagName('html')[0];
    htmlRoot.setAttribute('itemScope', 'itemscope');
    htmlRoot.setAttribute('itemType', 'https://schema.org/FAQPage');

    return () => {
      htmlRoot.removeAttribute('itemScope');
      htmlRoot.removeAttribute('itemType');
    };
  }, []);

  return <FaqPage content={content} />;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { data } = await getStory('faq', context.locale);

  const filteredData = {
    ...data,
    story: {
      ...data.story,
      content: {
        ...data.story.content,
        body: data.story.content.body
          .filter((block: any) => block.section === 'sprenger')
          .map((block: any) => ({
            ...block,
            entries: block.entries.filter((e: any) => !e.hide),
          }))
          .filter((block: any) => block.entries.length > 0),
      },
    },
  };

  return {
    props: {
      preview: context.preview || false,
      story: filteredData.story ?? false,
    },
    revalidate: getValidationTime(),
  };
};

export default FAQ;
